var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-linn-text font-linn leading-normal tracking-widest max-w-artboard uppercase py-12 pl-8 pr-4 md_p-20 md_text-2xl lg_pt-20 lg_pl-36 lg_pb-24 lg_pr-72 text-lg lg_text-4xl lg_leading-tight"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }